import { render, staticRenderFns } from "./ShoppingItemCard.vue?vue&type=template&id=6447890c&scoped=true&"
import script from "./ShoppingItemCard.vue?vue&type=script&lang=js&"
export * from "./ShoppingItemCard.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingItemCard.vue?vue&type=style&index=0&id=6447890c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447890c",
  null
  
)

export default component.exports